import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const REACT_ENV = import.meta.env.VITE_REACT_ENV;
const isLocal = import.meta.env.VITE_REACT_LOCAL === "true";

if (!isLocal) {
  Sentry.init({
    dsn: "https://4cdf7846d1aa957fd415501eb4d471d4@o4507858230902784.ingest.de.sentry.io/4508255373099088",
    environment: REACT_ENV,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
